import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { Box, Drawer, AppBar, Toolbar, Typography, List, ListItem, ListItemButton, ListItemIcon, ListItemText, IconButton, Avatar, Badge } from "@mui/material";
import NotificationBell from "./NotificationBell";
// Faz AY (2026-05-10): Cmd+K Global Hızlı Arama
import QuickSearch from "./QuickSearch";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import SettingsIcon from "@mui/icons-material/Settings";
import DashboardIcon from "@mui/icons-material/Dashboard";
import InventoryIcon from "@mui/icons-material/Inventory";
import CategoryIcon from "@mui/icons-material/Category";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PeopleIcon from "@mui/icons-material/People";
import NotificationsIcon from "@mui/icons-material/Notifications";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import LogoutIcon from "@mui/icons-material/Logout";
import EmailIcon from "@mui/icons-material/Email";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CampaignIcon from "@mui/icons-material/Campaign";
import BarChartIcon from "@mui/icons-material/BarChart";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import SettingsInputComponentIcon from "@mui/icons-material/SettingsInputComponent";
// Faz 12a (2026-04-29): "Audit Log" sidebar menu ogesi icin ikon
import HistoryIcon from "@mui/icons-material/History";
// Faz 14b (2026-04-30): "Sepeti Terk Hatirlatma" sidebar ikonu
import RemoveShoppingCartIcon from "@mui/icons-material/RemoveShoppingCart";
// Faz 14a (2026-04-30): "Hos Geldin Serisi" sidebar ikonu
import WavingHandIcon from "@mui/icons-material/WavingHand";
// Faz I (2026-05-06): NPS Dashboard + Kupon Yönetim sidebar ikonları
import StarIcon from "@mui/icons-material/Star";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
// Faz J (2026-05-06): RFM Müşteri Analizi sidebar ikonu
import GroupsIcon from "@mui/icons-material/Groups";
// Faz K (2026-05-06): Cross-sell Intelligence sidebar ikonu
import ConnectingAirportsIcon from "@mui/icons-material/ConnectingAirports";
// Faz L (2026-05-06): Sales Funnel sidebar ikonu (huni şeklinde)
import FilterListIcon from "@mui/icons-material/FilterList";
// Faz M (2026-05-06): Action Center sidebar ikonu
import NotificationImportantIcon from "@mui/icons-material/NotificationImportant";
// Faz N (2026-05-06): Forecast sidebar ikonu (zaman + grafik)
import QueryStatsIcon from "@mui/icons-material/QueryStats";
// Faz P (2026-05-06): Site Trafiği sidebar ikonu
import PublicIcon from "@mui/icons-material/Public";
// Faz R (2026-05-06): Cohort sidebar ikonu (heatmap/grid)
import GridViewIcon from "@mui/icons-material/GridView";
// Faz T (2026-05-06): Customer Journey sidebar ikonu (route/timeline)
import RouteIcon from "@mui/icons-material/Route";
// Faz U (2026-05-06): Email Campaign Performance sidebar ikonu
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
// Faz V (2026-05-06): Sales Pattern Heatmap sidebar ikonu
import CalendarViewWeekIcon from "@mui/icons-material/CalendarViewWeek";
// Faz X (2026-05-06): Mobile Cockpit sidebar ikonu
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
// Faz Y (2026-05-06): Category & Brand Sales sidebar ikonu
import CategoryIcon2 from "@mui/icons-material/Category";
// Faz Z (2026-05-06): Smart Recommendations sidebar ikonu (ampul = öneri)
import LightbulbIcon from "@mui/icons-material/Lightbulb";
// Faz AA (2026-05-07): Geographic Analytics sidebar ikonu (harita)
import MapIcon from "@mui/icons-material/Map";
// Faz AB (2026-05-07): Product 360 sidebar ikonu
import ScreenSearchDesktopIcon from "@mui/icons-material/ScreenSearchDesktop";
// Faz AC (2026-05-07): Drip Campaign Builder sidebar ikonu
import AccountTreeIcon from "@mui/icons-material/AccountTree";
// Faz AD (2026-05-07): System Health + Backup sidebar ikonu
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
// Faz AF (2026-05-07): Aylık Hedef sidebar ikonu (kupa)
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
// Faz AK (2026-05-07): WhatsApp sidebar ikonu
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
// Faz AM (2026-05-07): Notes sidebar ikonu
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
// Faz AN (2026-05-07): Subscriptions sidebar ikonu
import RepeatIcon from "@mui/icons-material/Repeat";
// Faz AO (2026-05-07): Reviews Moderation sidebar ikonu
import RateReviewIcon from "@mui/icons-material/RateReview";
// Faz AQ (2026-05-07): Returns / İade sidebar ikonu
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
// Faz AT (2026-05-07): Admin User Management sidebar ikonu
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
// Faz AU (2026-05-07): Bulk Customer Import sidebar ikonu
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { getUsers } from "../services/api";

const DRAWER_WIDTH = 240;

// ──────────────────────────────────────────────────────────────────────
// Faz AT (2026-05-07): JWT permissions parse helper
// JWT'de permissions array var. 'admin.full' = wildcard (her sayfaya erişim).
// Eski JWT'lerde permissions yok → graceful fallback: tüm sayfalar görünür.
// ──────────────────────────────────────────────────────────────────────
function getUserPermissions() {
  const token = localStorage.getItem("token");
  if (!token) return { full: true, perms: [] };
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const perms = Array.isArray(payload.permissions) ? payload.permissions : [];
    const isFull = perms.includes("admin.full") || perms.length === 0;
    return { full: isFull, perms };
  } catch (e) {
    return { full: true, perms: [] };  // Parse hatası → graceful fallback
  }
}

// Path → permission key mapping
// Yeni sayfa eklendiğinde bu map'e de ekle
function permissionForPath(path) {
  const map = {
    "/cockpit": "page.cockpit",
    "/dashboard": "page.dashboard",
    "/dashboard-v2": "page.dashboard",
    "/notes": "page.notes",
    "/action-center": "page.action_center",
    "/site-traffic": "page.site_traffic",
    "/geo": "page.geo",
    "/journey": "page.journey",
    "/reports": "page.reports",
    "/categories": "page.categories",
    "/products": "page.products",
    "/product360": "page.product360",
    "/orders": "page.orders",
    "/subscriptions": "page.subscriptions",
    "/users": "page.users",
    "/suppliers": "page.suppliers",
    "/email-campaign": "page.email_campaign",
    "/email-performance": "page.email_perf",
    "/whatsapp": "page.whatsapp",
    "/drip-builder": "page.drip",
    "/pazar-analizi": "page.pazar_analizi",
    "/marketing": "page.marketing",
    "/settings": "page.settings",
    "/system-health": "page.system_health",
    "/stock": "page.stock",
    "/b2b-pricing": "page.b2b_pricing",
    "/quotes": "page.quotes",
    "/cari-hesap": "page.cari",
    "/push-campaigns": "page.push",
    "/campaigns": "page.campaigns",
    "/import-export": "page.import_export",
    "/integrations": "page.integrations",
    "/audit-log": "page.audit_log",
    "/abandoned-cart": "page.abandoned_cart",
    "/welcome-email": "page.welcome_email",
    "/pending": "page.pending_users",
    "/nps": "page.nps",
    "/coupons": "page.coupons",
    "/rfm": "page.rfm",
    "/silent-customers": "page.rfm",  // Aynı RBAC kategoride — müşteri analizi
    "/cohort": "page.cohort",
    "/cross-sell": "page.cross_sell",
    "/funnel": "page.funnel",
    "/recommendations": "page.recommendations",
    "/forecast": "page.forecast",
    "/sales-pattern": "page.sales_pattern",
    "/category-sales": "page.category_sales",
    "/monthly-goals": "page.monthly_goals",
    "/reviews": "page.reviews",
    "/returns": "page.returns",
    "/admin-users": "admin.users.manage",
    "/bulk-import": "page.users",
    "/bulk-product-import": "page.products",
    "/stock-adjustments": "page.stock"
  };
  return map[path] || null;  // null = anyone
}

export default function Layout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [pendingCount, setPendingCount] = useState(0);
  const logout = () => { localStorage.clear(); navigate("/login"); };

  // Faz AT: kullanıcı yetkilerini JWT'den oku
  const userPerms = getUserPermissions();

  useEffect(() => {
    const load = () => {
      getUsers().then(r => {
        const count = r.data.filter(u => u.status === "pending_approval").length;
        setPendingCount(count);
      }).catch(() => {});
    };
    load();
    const interval = setInterval(load, 30000);
    return () => clearInterval(interval);
  }, []);

  const MENU = [
    // Faz X (2026-05-06): Mobile Cockpit — owner cep için tek sayfa
    { text: "📱 Cockpit", icon: <PhoneAndroidIcon />, path: "/cockpit" },
    // Faz AM (2026-05-07): Notlarım — sticky memos
    { text: "📝 Notlarım", icon: <StickyNote2Icon />, path: "/notes" },
    { text: "Dashboard", icon: <DashboardIcon />, path: "/dashboard" },
    { text: "🎯 Yönetim Merkezi", icon: <BarChartIcon />, path: "/dashboard-v2" },
    // Faz M (2026-05-06): Action Center — günlük operasyonel uyarı merkezi
    { text: "🔔 Action Center", icon: <NotificationImportantIcon />, path: "/action-center" },
    // Faz Z (2026-05-06): Smart Recommendations — proaktif öneri merkezi
    { text: "💡 Akıllı Öneriler", icon: <LightbulbIcon />, path: "/recommendations" },
    // Faz AF (2026-05-07): Aylık hedef + progress tracker
    { text: "🏆 Aylık Hedefler", icon: <EmojiEventsIcon />, path: "/monthly-goals" },
    // Faz P (2026-05-06): Site Trafiği — canlı ziyaretçi takibi
    { text: "🌐 Site Trafiği", icon: <PublicIcon />, path: "/site-traffic" },
    // Faz AA (2026-05-07): Coğrafi trafik (ülke/şehir)
    { text: "🗺️ Coğrafi Trafik", icon: <MapIcon />, path: "/geo" },
    // Faz T (2026-05-06): Customer Journey — session bazli sayfa yolculugu
    { text: "🛤️ Journey Map", icon: <RouteIcon />, path: "/journey" },
    { text: "Raporlar", icon: <BarChartIcon />, path: "/reports" },
    { text: "Kategoriler", icon: <CategoryIcon />, path: "/categories" },
    { text: "Urunler", icon: <InventoryIcon />, path: "/products" },
    // Faz AB (2026-05-07): Product 360 — tek ürün detay görünüm
    { text: "🔍 Ürün 360", icon: <ScreenSearchDesktopIcon />, path: "/product360" },
    // Faz AV (2026-05-07): Toplu ürün CSV upsert
    { text: "📦 Toplu Ürün Import", icon: <UploadFileIcon />, path: "/bulk-product-import" },
    { text: "Siparisler", icon: <ShoppingCartIcon />, path: "/orders" },
    // Faz AN (2026-05-07): Düzenli sipariş abonelikleri (B2B repeat order)
    { text: "🔁 Düzenli Sipariş", icon: <RepeatIcon />, path: "/subscriptions" },
    { text: "Musteriler", icon: <PeopleIcon />, path: "/users" },
    // Faz AU (2026-05-07): Toplu müşteri CSV import
    { text: "📤 Toplu Müşteri Import", icon: <UploadFileIcon />, path: "/bulk-import" },
    { text: "Tedarikciler", icon: <LocalShippingIcon />, path: "/suppliers" },
    { text: "Email Reklam", icon: <EmailIcon />, path: "/email-campaign" },
    // Faz U (2026-05-06): Brevo open/click/bounce takibi
    { text: "📧 Email Performans", icon: <MarkEmailReadIcon />, path: "/email-performance" },
    // Faz AK (2026-05-07): WhatsApp Business mesaj paneli
    { text: "💬 WhatsApp", icon: <WhatsAppIcon />, path: "/whatsapp" },
    // Faz AC (2026-05-07): Drip kampanya yönetimi (panelden CRUD)
    { text: "🌳 Drip Kampanya", icon: <AccountTreeIcon />, path: "/drip-builder" },
    { text: "📊 Pazar Analizi", icon: <BarChartIcon />, path: "/pazar-analizi" },
    { text: "🚀 Pazarlama Merkezi", icon: <RocketLaunchIcon />, path: "/marketing" },
    { text: "Stok Yönetimi", icon: <WarningAmberIcon />, path: "/stock" },
    // Faz AW (2026-05-07): Stok manuel düzeltme — fiziksel sayım sonrası
    { text: "🔧 Stok Düzeltme", icon: <WarningAmberIcon />, path: "/stock-adjustments" },
    { text: "B2B Fiyatlandırma", icon: <AttachMoneyIcon />, path: "/b2b-pricing" },
    { text: "Teklifler", icon: <RequestQuoteIcon />, path: "/quotes" },
    { text: "Cari Hesap", icon: <AccountBalanceIcon />, path: "/cari-hesap" },
    { text: "Push Kampanyalar", icon: <CampaignIcon />, path: "/push-campaigns" },
    { text: "Broşür / Kampanya", icon: <CampaignIcon />, path: "/campaigns" },
    { text: "İçe / Dışa Aktar", icon: <ImportExportIcon />, path: "/import-export" },
    { text: "Entegrasyonlar", icon: <SettingsInputComponentIcon />, path: "/integrations" },
    // Faz 12a (2026-04-29): Tum admin islemlerinin merkezi gorunumu
    { text: "Audit Log", icon: <HistoryIcon />, path: "/audit-log" },
    // Faz 14b (2026-04-30): Sepeti Terk Hatirlatma raporu
    { text: "Sepeti Terk", icon: <RemoveShoppingCartIcon />, path: "/abandoned-cart" },
    // Faz 14a (2026-04-30): Hos Geldin Serisi (welcome drip series funnel raporu)
    { text: "Hoş Geldin Serisi", icon: <WavingHandIcon />, path: "/welcome-email" },
    // Faz I (2026-05-06): NPS skor + Kupon yönetim sayfaları
    { text: "⭐ NPS Skoru", icon: <StarIcon />, path: "/nps" },
    // Faz AO (2026-05-07): Müşteri ürün yorumları moderasyonu
    { text: "💬 Yorumlar", icon: <RateReviewIcon />, path: "/reviews" },
    // Faz AQ (2026-05-07): İade talepleri moderasyon — yasal/operasyonel öncelik
    { text: "↩️ İade Talepleri", icon: <AssignmentReturnIcon />, path: "/returns" },
    // Faz AT (2026-05-07): Admin Kullanıcı Yönetimi (sadece super admin görür)
    { text: "🔐 Admin Kullanıcılar", icon: <AdminPanelSettingsIcon />, path: "/admin-users" },
    { text: "🎟️ Kuponlar", icon: <LocalOfferIcon />, path: "/coupons" },
    // Faz J (2026-05-06): RFM müşteri analizi (champions/at_risk/lost vb.)
    { text: "👥 RFM Analizi", icon: <GroupsIcon />, path: "/rfm" },
    // Faz BI (2026-05-10): Sessiz Müşteriler — pasif müşteri uyandırma
    { text: "📞 Sessiz Müşteriler", icon: <GroupsIcon />, path: "/silent-customers" },
    // Faz R (2026-05-06): Cohort & Retention (aylik tutma)
    { text: "📅 Cohort/Retention", icon: <GridViewIcon />, path: "/cohort" },
    // Faz K (2026-05-06): Cross-sell pair viewer (bundle fikri)
    { text: "🔗 Cross-Sell", icon: <ConnectingAirportsIcon />, path: "/cross-sell" },
    // Faz L (2026-05-06): Sales Funnel (visit → order conversion)
    { text: "🎯 Sales Funnel", icon: <FilterListIcon />, path: "/funnel" },
    // Faz N (2026-05-06): Forecast (stok + ciro tahminleme)
    { text: "🔮 Forecast", icon: <QueryStatsIcon />, path: "/forecast" },
    // Faz V (2026-05-06): Sales Pattern (saat/gün heatmap)
    { text: "🗓️ Sales Pattern", icon: <CalendarViewWeekIcon />, path: "/sales-pattern" },
    // Faz Y (2026-05-06): Kategori + Marka performans + sepete eklenen
    { text: "📦 Kategori & Marka", icon: <CategoryIcon2 />, path: "/category-sales" },
    {
      text: "Yeni Onaylar",
      icon: <Badge badgeContent={pendingCount} color="error"><NotificationsIcon /></Badge>,
      path: "/pending"
    },
    // Faz G: Sistem Ayarları
    { text: "⚙️ Ayarlar", icon: <SettingsIcon />, path: "/settings" },
    // Faz AD (2026-05-07): Sistem sağlık + yedekleme — felaket kurtarma için
    { text: "🩺 Sistem Sağlığı", icon: <HealthAndSafetyIcon />, path: "/system-health" },
  ];

  return (
    <Box sx={{ display: "flex" }}>
      {/* Faz AY: Global Cmd+K spotlight dialog (her sayfada erişilebilir) */}
      <QuickSearch />
      <AppBar position="fixed" sx={{ zIndex: 1201, bgcolor: "#1a237e" }}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 700 }}>Miksan Plastik Admin</Typography>
          {/* Faz AY: Cmd+K hint (sadece bilgi — gerçek shortcut global) */}
          <Box sx={{ mr: 2, px: 1.5, py: 0.5, border: "1px solid rgba(255,255,255,0.4)", borderRadius: 1, fontSize: 12, opacity: 0.85, cursor: "pointer", display: { xs: "none", sm: "block" } }}
               onClick={() => window.dispatchEvent(new KeyboardEvent("keydown", { key: "k", ctrlKey: true }))}>
            🔍 Hızlı Arama (Ctrl+K)
          </Box>
          {/* Faz G: Bildirim ikonu (canlı alert) */}
          <NotificationBell />
          <Avatar sx={{ bgcolor: "#ff6f00", mr: 1, ml: 1 }}>A</Avatar>
          <IconButton color="inherit" onClick={logout}><LogoutIcon /></IconButton>
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" sx={{ width: DRAWER_WIDTH, "& .MuiDrawer-paper": { width: DRAWER_WIDTH, boxSizing: "border-box", mt: 8 } }}>
        <List>
          {/* Faz AT: permission filter — userPerms.full=true ise tüm menü gözükür,
              değilse sadece izinli sayfalar. permissionForPath null dönerse herkese açık. */}
          {MENU.filter(item => {
            if (userPerms.full) return true;
            const reqPerm = permissionForPath(item.path);
            if (!reqPerm) return true;  // path mapping yoksa default göster
            return userPerms.perms.includes(reqPerm);
          }).map(item => (
            <ListItem key={item.text} disablePadding>
              <ListItemButton
                selected={location.pathname === item.path}
                onClick={() => navigate(item.path)}
                sx={{
                  "&.Mui-selected": { bgcolor: "#e8eaf6" },
                  ...(item.path === "/pending" && pendingCount > 0 ? { bgcolor: "#FFF8E1" } : {})
                }}>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3, mt: 8 }}>
        <Outlet />
      </Box>
    </Box>
  );
}